import { SET_SHOW_WELCOME_MODAL } from "../actions/common"

export default function commonReducer(state = {}, action) {
  switch (action.type) {
    case SET_SHOW_WELCOME_MODAL:
      return { ...state, showWelcomeModal: action.action }
    default:
      return state
  }
}
